import { useState, useRef } from "react";
import { createPortal } from "react-dom";
import { extractOrderItems, getStudentName } from "../../utils/StringUtils";

const LateralPopover = ({ details, index }) => {
    const [hoverIndex, setHoverIndex] = useState(null);
    const buttonRef = useRef(null);
    const [position, setPosition] = useState({ top: 0, left: 0 });

    const formatCurrency = (value) => `R$ ${value.toFixed(2)}`;

    const handleMouseEnter = () => {
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setPosition({
                top: rect.top + window.scrollY,
                left: rect.right + window.scrollX + 10
            });
        }
        setHoverIndex(index);
    };

    const handleMouseLeave = () => {
        setHoverIndex(null);
    };

    return (
        <div>
            <button
                ref={buttonRef}
                className="bg-gray-200 px-2 py-1 rounded mt-1"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                Detalhes
            </button>

            {hoverIndex === index &&
                details?.length > 0 &&
                createPortal(
                    <div
                        className="bg-white border rounded shadow-lg p-3 w-128"
                        style={{
                            position: "absolute",
                            top: position.top,
                            left: position.left,
                            zIndex: 9999,
                        }}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        {details.map((d, idx) => (
                            <div key={idx} className="mb-3 border-b last:border-b-0 pb-2">
                                <div className="flex justify-between mb-1">
                                    {d.orderId && <span className="font-semibold">Pedido #{d.orderId}</span>}
                                    {d.clientId && <span className="text-gray-600">Login do Aluno: {d.clientId}</span>}
                                </div>

                                {d.itemsList && (
                                    <ul className="list-disc list-inside text-sm">
                                        {extractOrderItems(d.itemsList).map((itemDetail, itemIdx) => (
                                            <li key={itemIdx} className="ml-2">
                                                {itemDetail.name} x{itemDetail.quantity}
                                            </li>
                                        ))}
                                    </ul>
                                )}

                                <div className="text-right font-medium">Valor: {formatCurrency(d.totalValue)}</div>
                            </div>
                        ))}

                    </div>,
                    document.body
                )}
        </div>
    );
};

export default LateralPopover;
